export const SITE = {
  name: "Alejandra's",
  fullName: "Alejandra's Authentic Mexican Restaurant",
  rating: "4.5",
  reviews: 703,
  priceRange: "$10–20",
  address: "301 2nd St, Aurora, IN 47001",
  phone: "(812) 655-9791",
  phoneHref: "tel:+18126559791",
  directionsUrl:
    "https://www.google.com/maps/dir/?api=1&destination=301+2nd+St,+Aurora,+IN+47001",
  hours: [
    { days: "Monday – Thursday", time: "11:00 AM – 9:30 PM" },
    { days: "Friday – Saturday", time: "11:00 AM – 10:30 PM" },
    { days: "Sunday", time: "11:00 AM – 9:00 PM" },
  ],
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1700625916627-16ad4fb0553c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920",
  tacos: "https://images.unsplash.com/photo-1582234372722-50d7ccc30ebd?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  fajitas: "https://images.unsplash.com/photo-1625166913168-9135c6ffddcb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  margarita: "https://images.unsplash.com/photo-1625167171750-419e95f877d8?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  interiorDining: "https://images.unsplash.com/photo-1622140739492-f82f386260b5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  interiorAmbiance: "https://images.unsplash.com/photo-1652195960911-c9f55224bd89?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  interiorBooth: "https://images.unsplash.com/photo-1650490632010-e18cbb694dd1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  churros: "https://images.unsplash.com/photo-1652465485267-9398f1495c46?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  cocktailSpecial: "https://images.unsplash.com/photo-1764642611488-c594010f8f7b?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  cocktailOrange: "https://images.unsplash.com/photo-1681394420987-1aaac01089f1?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
};

export const GALLERY = [
  { src: IMAGES.tacos, label: "Street tacos, fresh off the plancha", cat: "Food" },
  { src: IMAGES.fajitas, label: "Texas fajitas, still sizzling", cat: "Food" },
  { src: IMAGES.margarita, label: "The house margarita, hand-shaken", cat: "Drinks" },
  { src: IMAGES.interiorDining, label: "The family dining room", cat: "Ambiance" },
  { src: IMAGES.churros, label: "Churros con chocolate, fried to order", cat: "Food" },
  { src: IMAGES.cocktailSpecial, label: "Golden hour at the cantina", cat: "Drinks" },
  { src: IMAGES.interiorAmbiance, label: "Warm corners, long evenings", cat: "Ambiance" },
  { src: IMAGES.cocktailOrange, label: "Paloma with a tajín rim", cat: "Drinks" },
  { src: IMAGES.interiorBooth, label: "Your booth is waiting", cat: "Ambiance" },
  { src: IMAGES.hero, label: "The full Alejandra's spread", cat: "Food" },
];

export const scrollToId = (id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (window.__lenis) {
    window.__lenis.scrollTo(el, { offset: -72, duration: 1.4 });
  } else {
    el.scrollIntoView({ behavior: "smooth" });
  }
};
